module.exports = __webpack_public_path__ + "static/media/公式识别).ac4a2216.png";